import React, {useState, useEffect} from "react";
import WhereAmI from "../../components/WhereAmI";
import Weather from "../../components/Weather";
import useGlobal from "../../store";

const Layer2 = (props) => {
    const [currentState, currentActions] = useGlobal();
    const [module, setModule] = useState(props.submodule);

    useEffect(() => {
        setModule(currentState.currentModule)
    }, [currentState])

    return <div className="layer2">
        <WhereAmI module={props.submodule} context={props.context} action={props.action} />
        <Weather /> 
    </div>
}

export default Layer2;